import { createMarketplaceEventFactory } from '../index';
export const getInstallButtonClickedEvent = createMarketplaceEventFactory('Marketplace', 'Install Button Clicked');